import { mbSize, Media, panRight } from '@foxrenderfarm/common'
import { Link } from 'gatsby'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{ $showTopBanner: boolean; $hiddenInMobile?: boolean }>`
  width: 300px;
  display: flex;
  position: sticky;
  top: ${({ $showTopBanner }) => ($showTopBanner ? '158px' : '108px')};
  z-index: 1;
  align-self: flex-start;
  max-height: calc(100vh - ${({ $showTopBanner }) => ($showTopBanner ? '158px' : '108px')});
  overflow-y: auto;
  ${Media.greaterThan(Media.small)} {
    &::-webkit-scrollbar {
      width: 16px;
      background: #fafafa;
      border-left: 1px solid #e8e8e8;
      border-right: 1px solid #e8e8e8;
    }
    &::-webkit-scrollbar-track {
      border-radius: 4px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: 4px solid transparent;
      border-radius: 9px;
      background-clip: content-box;
    }
  }
  ${Media.lessThan(Media.small)} {
    display: ${({ $hiddenInMobile }) => ($hiddenInMobile ? 'none' : 'flex')};
    position: relative;
    top: unset;
    width: ${mbSize(600)};
    max-height: unset;
    justify-content: center;
    -webkit-tap-highlight-color: transparent;
  }
`

export const CatalogueWrapper = styled.div<{ $showTopBanner: boolean }>`
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  width: 260px;
  ${Media.lessThan(Media.small)} {
    padding-top: 0;
    width: ${mbSize(520)};
  }
`

export const Collapse = styled.div<{ $isExpand: boolean; $height?: number; $level: number }>`
  flex-shrink: 0;
  cursor: pointer;
  width: 100%;
  max-height: ${({ $isExpand, $height }) => ($isExpand ? '2000px' : `${$height}px`)};
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s;
  margin-bottom: ${({ $level }) => ($level === 1 ? '10px' : '0')};
  &:not(:last-child) {
    margin-bottom: 20px;
  }
  ${Media.lessThan(Media.small)} {
    &:not(:last-child) {
      margin-bottom: ${mbSize(12)};
    }
  }
`

export const ParentDir = styled.div<{ $isActive: boolean; $isExpand: boolean; $level: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${({ $level }) => ($level === 1 ? '16px' : '14px')};
  padding: ${({ $level }) => `10px 20px 10px ${$level * 20}px`};
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 400)};
  color: ${({ $isActive }) => ($isActive ? '#F3512B' : '#333333')};
  background: ${({ $isActive }) => ($isActive ? '#FFF4F1' : 'unset')};
  svg {
    transition: all 0.3s;
    transform: rotate(${({ $isExpand }) => ($isExpand ? '90deg' : '0deg')});
  }
  &:hover {
    background: #fafafa;
  }
  ${Media.lessThan(Media.small)} {
    font-size: ${({ $level }) => ($level === 1 ? mbSize(32) : mbSize(28))};
  }
`

export const SonDir = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #666666;
`

export const CatalogueItem = styled(Link)<{ $level: number; $isActive: boolean }>`
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  width: 260px;
  padding: ${({ $level }) => `10px 20px 10px ${$level * 20}px`};
  font-size: ${({ $level }) => ($level === 1 ? '16px' : '14px')};
  margin-bottom: ${({ $level }) => ($level === 1 ? '10px' : '0')};
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 400)};
  color: ${({ $isActive }) => ($isActive ? '#F3512B' : '#333333')};
  background: ${({ $isActive }) => ($isActive ? '#FFF4F1' : 'unset')};
  border-radius: 4px;
  transition: background 0.3s;
  ${({ $level, $isActive }) =>
    $level === 3 &&
    css`
      padding: 10px 20px 10px ${$level * 20 + 14}px;
      &::before {
        content: '';
        position: absolute;
        top: 17px;
        left: ${$level * 20}px;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: ${$isActive ? '#F3512B' : '#333333'};
      }
    `}
  &:hover {
    background: ${({ $isActive }) => ($isActive ? '#FFF4F1' : '#fafafa')};
  }
  ${Media.lessThan(Media.small)} {
    margin-bottom: ${({ $level }) => ($level === 1 ? mbSize(12) : '0')};
    font-size: ${({ $level }) => ($level === 1 ? mbSize(32) : mbSize(28))};
    padding: ${({ $level }) => `${mbSize(22)} ${mbSize(40)} ${mbSize(22)} ${mbSize(40 * $level)}`};
    ${({ $level }) =>
      $level === 3 &&
      css`
        padding: ${mbSize(22)} ${mbSize(40)} ${mbSize(22)} ${mbSize(40 * $level + 28)};
        &::before {
          top: ${mbSize(35)};
          width: ${mbSize(8)};
          height: ${mbSize(8)};
        }
      `}
  }
`

export const ChatWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 260px;
  height: 250px;
  border-radius: 8px;
  overflow: hidden;
  padding: 30px 20px;
  flex-shrink: 0;
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

export const ChatTitle = styled.div`
  font-size: 23px;
  font-weight: 800;
  color: #333333;
`

export const ChatDesc = styled.div`
  margin-top: 8px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
`

export const ChatButton = styled.div`
  cursor: pointer;
  margin-top: 16px;
  width: 220px;
  height: 30px;
  border-radius: 100px;
  background: #f3512b;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  svg {
    margin-left: 8px;
  }
`

export const CatalogueDrawerWrapper = styled.div`
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  z-index: 9999999999;
  display: flex;
  justify-content: center;
`

export const CatalogueDrawerMask = styled.div<{ $drawerHeight: string }>`
  top: ${mbSize(120)};
  position: fixed;
  width: 100%;
  height: calc(${({ $drawerHeight }) => $drawerHeight} - ${mbSize(120)});
  z-index: -1;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  ${Media.lessThan(Media.small)} {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }
`

export const CatalogueDrawerContent = styled.div<{ $drawerHeight: string }>`
  position: absolute;
  height: calc(${({ $drawerHeight }) => $drawerHeight} - ${mbSize(120)});
  width: fit-content;
  top: ${mbSize(120)};
  left: 0;
  background-color: #ffffff;
  animation: ${panRight} 300ms;
  overflow: auto;
`
